import { compose } from 'recompose'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { selectFirstPrequal } from 'src/store/selectors/prequal'

const HasPrequalScreenContainer = compose(
  connect(state => ({
    firstPrequal: selectFirstPrequal(state)
  })),
  injectIntl
)

export default HasPrequalScreenContainer
